import styled, { css, keyframes } from "styled-components";

import {
  SCENSUM_WEBSITE_HEADER_HEIGHT,
  BFC_PROGRESS_BAR_HEIGHT_MOBILE,
} from "../../constants/constants";

const pulse = keyframes`
  0%   { transform: scale(1);    opacity: 1;   }
  40%  { transform: scale(1.12); opacity: 0.7; }
  100% { transform: scale(1);    opacity: 1;   }
`;

// Fixed rather than sticky: an overlay never changes document height, so a
// scroll can never shrink the page and bounce the user back up.
export const _Bar = styled.div`
  position: fixed;
  top: calc(
    ${SCENSUM_WEBSITE_HEADER_HEIGHT} + ${BFC_PROGRESS_BAR_HEIGHT_MOBILE}
  );
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  padding: 7px 15px;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 2px 6px rgba(175, 176, 179, 0.4);
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;

  @media (min-width: 768px) {
    display: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const _ThumbButton = styled.button`
  position: relative;
  flex: none;
  padding: 0;
  border: 1px solid lightgrey;
  border-radius: 4px;
  background: none;
  line-height: 0;
  cursor: pointer;

  ${(props) =>
    props.$pulsing &&
    css`
      animation: ${pulse} 0.4s ease-in-out;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const _ZoomBadge = styled.span`
  position: absolute;
  right: -6px;
  bottom: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  color: ${({ theme }) => theme.link};
  font-size: 11px;
`;

export const _Details = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const _NameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const _Season = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: normal;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const _SizeRow = styled.div`
  margin-top: 2px;
  font-size: 12px;
`;

export const _Dimensions = styled.span`
  margin-left: 5px;
`;

export const _Price = styled.div`
  flex: none;
  text-align: right;
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => (props.$discounted ? props.theme.discount : "inherit")};
`;

export const _OrdinaryPrice = styled.div`
  font-size: 11px;
  font-weight: normal;
  text-decoration: line-through;
  color: ${({ theme }) => theme.grey};
`;
